/**
 * GradeHero — landing-page hero for /grade.
 *
 * Strong commercial positioning, social-proof trust line, and a primary CTA
 * that scrolls to the scanner. Visual mock card communicates the product
 * before the user ever clicks.
 */
import React from 'react';

export default function GradeHero({ stats, onStart }) {
  const totalReports = stats?.totalReports ?? 0;
  const last7 = stats?.last7Days ?? 0;
  const samples = stats?.calibrationSamples ?? 0;
  return (
    <section className="gp-hero">
      <div className="gp-hero__inner">
        <div className="gp-hero__copy">
          <span className="gp-eyebrow">Free · No sign-up</span>
          <h1 className="gp-h1">
            Pre-grade your card in seconds, not weeks.
          </h1>
          <p className="gp-lead">
            SilverGames AI grades Pokémon cards on the same four sub-grades
            PSA uses — centering, corners, edges, surface — straight from your
            phone or webcam. Get a confident PSA-style estimate before you
            spend a dime on real grading.
          </p>
          <div className="gp-hero__cta-row">
            <button type="button" className="gp-btn gp-btn--primary gp-btn--xl" onClick={onStart}>
              Grade your card
            </button>
            <a href="#how-it-works" className="gp-btn gp-btn--ghost gp-btn--xl">
              How it works
            </a>
          </div>
          <div className="gp-hero__trust">
            <div>
              <strong>{formatNumber(totalReports)}</strong>
              <span>cards graded</span>
            </div>
            <div>
              <strong>{formatNumber(last7)}</strong>
              <span>this week</span>
            </div>
            <div>
              <strong>{samples > 0 ? `${samples}` : '—'}</strong>
              <span>calibrated against real grades</span>
            </div>
          </div>
        </div>

        <div className="gp-hero__visual">
          <div className="gp-hero__card" aria-hidden="true">
            <span>Frame your card here</span>
            <div className="gp-hero__card__grade">PSA 9.5 est.</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function formatNumber(n) {
  if (!Number.isFinite(n)) return '0';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (n >= 1_000)     return (n / 1_000).toFixed(1) + 'k';
  return String(n);
}
